/**
 * @format
 * @module lib/commercial/bootstrap
 */
import vendor from "vendor";
import tgamConfig from "config/tgam";
import { mark, measure } from "lib/performance/user-timing";
import { BLOCKOUT_TYPES } from "lib/commercial/keytar/Template";
import keytarDone from "lib/commercial/keytar/keytar-done";
import { getProp } from "utils/utils";
import dfpAdsInit from "./dfp-ads";
import adSecurityInit from "./ad-security";
import admantxInit from "./ias-admantx";
import permutiveInit from "./permutive";
import { attachSlimcutScript } from "./dfp-ads/slimcut-ad";
import stickyLeaderboardInit from "./sticky-leaderboard";
import {
  getUserHashId,
  getUserHashIdEncrypted,
  getUserSophiId,
  getSophi3Id
} from "lib/identity/api";

export default function init() {
  mark("commercial_bootstrap_started");
  const isAdmin = getProp(tgamConfig, "env.isPbAdmin", false);
  const adsDisabled = getProp(tgamConfig, "env.adsDisabled", false);
  const kruxEnabled = getProp(tgamConfig, "env.kruxEnabled", false);
  if (!isAdmin && !adsDisabled) {
    if (kruxEnabled) {
      vendor.kruxInit();
    }
    const hashId = getUserHashId();
    const permutiveDone = getUserHashIdEncrypted(hashId).then(hashEcrypted => {
      permutiveInit({
        hash: hashId,
        hashExternal: hashEcrypted,
        sophi3: getSophi3Id(),
        sophi: getUserSophiId()
      });
    });
    Promise.all([permutiveDone, keytarDone]).then(values => {
      const data = values[1];
      // Don't run when Keytar blocks things from view
      if (data.accessAllowed || data.blockoutType === BLOCKOUT_TYPES.PREVIEW) {
        Promise.all([adSecurityInit(), admantxInit()]).then(() => {
          dfpAdsInit();
          stickyLeaderboardInit();
          attachSlimcutScript(); // Animated Ad appears as an article content inline ad.
        });
      }
    });
  }
  mark("commercial_bootstrap_done");
  measure("commercial_bootstrap");
}
